export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./responsiveImage.vue?vue&type=template&id=67828937"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/vue/components/responsiveImage.vue?vue&type=template&id=67828937
// module id = 42
// module chunks = 0